/* ML – Art, mirror & hardware product page (ml-product-cat). Gallery, options, in-page finish switching, AJAX add to cart. */
(function () {
  document.querySelectorAll('[data-ml-cat-pdp]').forEach(function (root) {
    var id = root.getAttribute('data-ml-cat-pdp');
    var data = { members: [] };
    try { data = JSON.parse(document.querySelector('script[data-ml-cat-data="' + id + '"]').textContent); } catch (e) {}
    var members = data.members || [];
    var member = members.filter(function (m) { return m.handle === data.current; })[0] || members[0];
    if (!member) return;
    var $ = function (s) { return root.querySelector(s); };
    var form = $('[data-ml-form]'), input = $('[data-ml-variant-input]'), priceEl = $('[data-ml-price]');
    var atc = $('[data-ml-atc]'), atcText = $('[data-ml-atc-text]'), msg = $('[data-ml-msg]');
    var mto = $('[data-ml-mto]'), fs = $('[data-ml-fs]'), so = $('[data-ml-so]'), more = $('[data-ml-more]');
    var rts = $('[data-ml-rts]'), rtsLow = $('[data-ml-rts-low]'), rtsQty = $('[data-ml-rts-qty]');
    var track = $('[data-ml-track]'), sticky = $('[data-ml-sticky]');

    /* keep ?view=… preview links working */
    root.querySelectorAll('[data-ml-keepq]').forEach(function (a) { if (location.search) a.href = a.getAttribute('href').split('?')[0] + location.search; });

    /* ---------- gallery ---------- */
    function slides() { return root.querySelectorAll('[data-ml-slide]'); }
    function goTo(i, smooth) { var s = slides()[i]; if (!s || !track) return; track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' }); }
    function setActive(i) {
      root.querySelectorAll('[data-ml-thumb]').forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      root.querySelectorAll('.ml-dots i').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      var c = $('[data-ml-count]'); if (c) c.textContent = i + 1;
    }
    root.addEventListener('click', function (e) { var t = e.target.closest('[data-ml-thumb]'); if (!t) return; var i = +t.getAttribute('data-ml-thumb'); goTo(i); setActive(i); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var best = 0, bd = Infinity;
          slides().forEach(function (s, k) { var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft); if (d < bd) { bd = d; best = k; } });
          setActive(best);
        });
      }, { passive: true });
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function rebuildGallery(m) {
      var im = m.images || [];
      if (!track || !im.length) return;
      track.innerHTML = im.map(function (x, k) {
        return '<figure class="ml-slide' + (k === 0 ? ' ml-slide--cut ml-slide--hero' : '') + '" data-ml-slide="' + k + '"><img src="' + x.src + '" srcset="' + x.srcset + '" sizes="(max-width: 749px) 92vw, 60vw" alt="' + esc(x.alt) + '" width="' + x.w + '" height="' + x.h + '"' + (k ? ' loading="lazy"' : '') + '>' + (k === 0 ? '<figcaption class="ml-cap ml-cap--dk">' + esc(m.title) + '</figcaption>' : '') + '</figure>';
      }).join('');
      var stage = $('[data-ml-stage]'); if (stage) stage.classList.toggle('ml-stage--single', im.length < 2);
      var th = $('[data-ml-thumbs]'), dots = $('[data-ml-dots]'), cb = $('[data-ml-countbox]'), tot = $('[data-ml-total]');
      if (th) { th.hidden = im.length < 2; th.innerHTML = im.map(function (x, k) { return '<button type="button" class="ml-thumb' + (k === 0 ? ' is-on ml-thumb--cut' : '') + '" data-ml-thumb="' + k + '" aria-label="Show image ' + (k + 1) + '"><img src="' + x.thumb + '" alt="" loading="lazy" width="80" height="80"></button>'; }).join(''); }
      if (dots) { dots.hidden = im.length < 2; dots.innerHTML = im.map(function (x, k) { return '<i' + (k === 0 ? ' class="is-on"' : '') + '></i>'; }).join(''); }
      if (cb) cb.hidden = im.length < 2; if (tot) tot.textContent = im.length;
      var grid = $('[data-ml-grid]');
      var n = Math.min(Math.max(im.length - 1, 0), 4); if (n === 3) n = 2;
      if (grid) {
        grid.hidden = n === 0;
        grid.classList.toggle('ml-grid--odd', n % 2 === 1);
        grid.innerHTML = im.slice(1, 1 + n).map(function (x) { return '<figure class="ml-tile"><img src="' + x.tile + '" alt="' + esc(x.alt) + '" loading="lazy" width="' + x.w + '" height="' + x.h + '"></figure>'; }).join('');
      }
      track.scrollTo({ left: 0, behavior: 'auto' }); setActive(0);
      var si = $('[data-ml-sticky-im]'); if (si) si.src = im[0].thumb;
    }

    /* ---------- variants ---------- */
    function selectedOptions() { var o = []; root.querySelectorAll('[data-ml-option]:checked').forEach(function (r) { o[+r.getAttribute('data-ml-option')] = r.value; }); return o; }
    function findVariant(opts) {
      var vs = member.variants;
      return vs.filter(function (v) { return v.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; }); })[0] || vs.filter(function (v) { return v.available; })[0] || vs[0];
    }
    /* merged listings: each finish/stone variant shows its own run of photos (from its featured image to the next one) */
    var allImgs = member.images || [], curG = null;
    function vStarts(m) { var s = []; (m.variants || []).forEach(function (x) { if (typeof x.vimg === 'number' && x.vimg >= 0 && s.indexOf(x.vimg) < 0) s.push(x.vimg); }); return s.sort(function (a, b) { return a - b; }); }
    var starts = vStarts(member), vgroups = starts.length > 1;
    function showGroup(v) {
      if (!vgroups || typeof v.vimg !== 'number' || v.vimg < 0 || v.vimg === curG) return;
      curG = v.vimg;
      var end = allImgs.length; starts.forEach(function (s) { if (s > v.vimg && s < end) end = s; });
      rebuildGallery({ images: allImgs.slice(v.vimg, end), title: member.title });
    }
    function applyVariant(v, fromUser) {
      if (!v) return;
      showGroup(v);
      input.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      atc.disabled = !v.available;
      atcText.textContent = v.available ? 'Add to cart — ' + v.price : 'Sold out';
      var inStock = v.t && v.q > 0;
      if (rts) { rts.hidden = !inStock; if (inStock) { rtsQty.textContent = v.q; rtsLow.hidden = v.q > 2; } }
      if (mto) mto.hidden = inStock || !v.available;
      if (fs) fs.hidden = inStock || !v.available;
      if (so) so.hidden = v.available;
      if (more) more.hidden = !v.available;
      v.options.forEach(function (o, i) { var l = root.querySelector('[data-ml-opt-label="' + i + '"]'); if (l) l.textContent = o; });
      if (sticky) {
        var sv = sticky.querySelector('[data-ml-sticky-var]'), sp = sticky.querySelector('[data-ml-sticky-price]'), sb = sticky.querySelector('[data-ml-sticky-btn]');
        if (sv) sv.textContent = member.variants.length > 1 ? v.title + ' · ' : '';
        if (sp) sp.textContent = v.price;
        if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      }
      if (fromUser) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {}
        input.dispatchEvent(new Event('change', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
      }
    }
    root.querySelectorAll('[data-ml-option]').forEach(function (r) { r.addEventListener('change', function () { applyVariant(findVariant(selectedOptions()), true); }); });

    /* ---------- hardware: other finishes, switched in place ---------- */
    root.querySelectorAll('[data-ml-fam-opt]').forEach(function (r) {
      r.addEventListener('change', function () {
        var m = members.filter(function (x) { return x.handle === r.value; })[0]; if (!m) return;
        var opts = selectedOptions();
        member = m;
        var lbl = $('[data-ml-fam-label]'); if (lbl) lbl.textContent = m.fin || m.title;
        var t = $('[data-ml-title]'); if (t) t.textContent = m.title;
        var c = $('[data-ml-title-crumb]'); if (c) c.textContent = m.title;
        var st = sticky && sticky.querySelector('[data-ml-sticky-title]'); if (st) st.textContent = m.title;
        var dim = $('[data-ml-dim]'), dr = $('[data-ml-dimrow]'); if (dim) { dim.textContent = m.dim; if (dr) dr.hidden = !/\d/.test(m.dim); }
        var multi = m.variants.length > 1;
        root.querySelectorAll('[data-ml-opt-pos]').forEach(function (f) { f.hidden = !multi; });
        if (multi) m.variants.forEach(function (v) { var p = root.querySelector('[data-ml-vprice="' + v.options[0].replace(/"/g, '\\"') + '"]'); if (p) p.textContent = v.price; });
        rebuildGallery(m);
        applyVariant(multi ? findVariant(opts) : m.variants[0], false);
        try { var u = new URL(m.url, location.origin); new URL(location.href).searchParams.forEach(function (val, k) { if (k !== 'variant') u.searchParams.set(k, val); }); history.replaceState({}, '', u.toString()); } catch (e) {}
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { id: +input.value } } }));
      });
    });

    /* ---------- quantity ---------- */
    var qty = $('[data-ml-qty-input]');
    root.querySelectorAll('[data-ml-qty]').forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + (+b.getAttribute('data-ml-qty'))); }); });

    /* ---------- add to cart (AJAX, falls back to a normal form post) ---------- */
    var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    function updateCartCount() {
      fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('.cart-count-number,[data-cart-count-number]').forEach(function (n) { n.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
      }).catch(function () {});
    }
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter !== atc) return;
        e.preventDefault();
        if (atc.disabled) return;
        atc.classList.add('is-loading'); atc.disabled = true;
        fetch(base + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            msg.hidden = false;
            if (res.ok) { msg.classList.remove('is-err'); msg.innerHTML = 'Added to your cart. <a href="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart">View cart</a>'; updateCartCount(); }
            else { msg.classList.add('is-err'); msg.textContent = res.j.description || res.j.message || 'Sorry, something went wrong. Please try again.'; }
          })
          .catch(function () { form.submit(); })
          .finally(function () { atc.classList.remove('is-loading'); var v = member.variants.filter(function (x) { return String(x.id) === String(input.value); })[0]; atc.disabled = v ? !v.available : false; });
      });
    }

    /* ---------- sticky mobile bar ---------- */
    var row = $('[data-ml-atc-row]');
    if (sticky && row && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) { var past = !en.isIntersecting && en.boundingClientRect.top < 0; sticky.classList.toggle('is-on', past); sticky.setAttribute('aria-hidden', past ? 'false' : 'true'); }); }).observe(row);
      sticky.querySelector('[data-ml-sticky-btn]').addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(atc); else atc.click(); row.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }

    /* ---------- chat: Gorgias if present, otherwise email ---------- */
    root.querySelectorAll('[data-ml-chat]').forEach(function (a) { a.addEventListener('click', function (e) { if (window.GorgiasChat && typeof GorgiasChat.open === 'function') { e.preventDefault(); GorgiasChat.open(); } }); });

    /* open on the variant in the URL, if any */
    var startV = member.variants.filter(function (v) { return String(v.id) === String(input.value); })[0];
    if (startV) applyVariant(startV, false);
  });
})();
